import React, { FunctionComponent } from 'react';

import styled from 'styled-components';
import Logo from '../Logo';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0 60px 64px;
`;

const Scene = styled.div`
  margin: 0px auto 0;
  display: flex;
  flex-direction: column;
  height: 120px;
  padding: 0px;
  perspective: 900px;
  width: 200px;
`;

const Div = styled.div`
  animation: rotating 3s ease infinite;
  height: 100%;
  margin: 5px 0;
  position: relative;
  transform-origin: 30%;
  transform-style: preserve-3d;
  transform: rotateX(-22.5deg) rotateY(45deg);
  width: 100%;

  :nth-child(1) {
    animation-delay: 0.15s;
    z-index: 4;
  }
  :nth-child(2) {
    animation-delay: 0.3s;
    z-index: 3;
  }
  :nth-child(3) {
    animation-delay: 0.45s;
    z-index: 2;
  }
  :nth-child(4) {
    animation-delay: 0.6s;
    z-index: 1;
  }

  p {
    background: #fff;
    color: #000;
    padding: 8px;
    position: absolute;
    width: 100px;
    height: 16px;
  }

  p:nth-child(1) {
    background: #000;
    color: #fff;
    transform: rotateY(90deg) translateZ(58px);
  }
  p:nth-child(2) {
    transform: rotateY(180deg) translateZ(58px);
  }
  p:nth-child(3) {
    background: #000;
    color: #fff;
    transform: rotateY(270deg) translateZ(58px);
  }
  p:nth-child(4) {
    transform: rotateY(0deg) translateZ(58px);
  }
`;

const AnimationSide: FunctionComponent = () => {
  return (
    <p>
      <Logo />
    </p>
  );
};

const AnimationLayer: FunctionComponent = () => {
  return (
    <Div>
      <AnimationSide />
      <AnimationSide />
      <AnimationSide />
      <AnimationSide />
    </Div>
  );
};

const Animations: FunctionComponent = () => {
  return (
    <Wrapper>
      <Scene>
        <AnimationLayer />
        <AnimationLayer />
        <AnimationLayer />
        <AnimationLayer />
      </Scene>
    </Wrapper>
  );
};

export default Animations;
